import { bopApi } from '@/lib/api/client';
import type { ReportType } from '@/services/api/reports';

const PROCESS_PATH = 'v1/accounts/cleanup/process';

export const ACCOUNT_CLEANUP_REPORT_TYPE: ReportType = 'account-cleanup';

export interface AccountCleanupRequest {
  /** S3 key of the account-cleanup report the PIDs were reviewed on; the API admits only its candidate rows */
  reportKey: string;
  accountHolderIds: string[];
  /** Audit justification, recorded against every account the run touches */
  auditReference: string;
  /** The API defaults to true; the UI always sends false. A dry run only reports what a live run would do */
  dryRun: boolean;
}

export interface AccountCleanupAccepted {
  reportKey: string;
  accounts: number;
  auditReference: string;
  dryRun: boolean;
  requestedBy: string;
  /** ISO-8601 */
  requestedAt: string;
}

/**
 * Starts an account cleanup run for PIDs reviewed on a report. The 202 only acknowledges the
 * request: the worker runs for minutes and announces the outcome CSV over the websocket as
 * `reportReady` / `reportFailed` with reportType 'account-cleanup', so pages must wait through
 * useAsyncReport.
 */
export const requestAccountCleanup = (body: AccountCleanupRequest) => bopApi.post(PROCESS_PATH, { json: body }).json<AccountCleanupAccepted>();
